import React from 'react';
import { ATMGrid, ATMHeader, ATMSegment, ATMTable } from 'shared-it-appmod-ui';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import Lang from 'src/libraries/language';
import { IRequest } from 'src/models/request.model';

type IProps = {
  data: IRequest;
};

const FlightRequestAccounting: React.FC<IProps> = ({ data }) => {
  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_REQUEST_ACCOUNTING}</ATMHeader>

      <ATMGrid columns={2}>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_REQUEST_COST_CENTER}>
            {data.request.costCenter}
          </FieldReadOnly>
        </ATMGrid.Column>
      </ATMGrid>

      <ATMTable>
        <ATMTable.Header>
          <ATMTable.Row>
            <ATMTable.HeaderCell>
              {Lang.LBL_REQUEST_WORK_ORDER_NUMBER}
            </ATMTable.HeaderCell>
            <ATMTable.HeaderCell>
              {Lang.LBL_REQUEST_IO_NUMBER}
            </ATMTable.HeaderCell>
            <ATMTable.HeaderCell>
              {Lang.LBL_REQUEST_PLAN_CATEGORY}
            </ATMTable.HeaderCell>
          </ATMTable.Row>
        </ATMTable.Header>

        <ATMTable.Body>
          {data.request.accounting.map((value, key) => (
            <ATMTable.Row key={`row_${key}`}>
              <ATMTable.Cell>{value.workOrder}</ATMTable.Cell>
              <ATMTable.Cell>{value.ioNo}</ATMTable.Cell>
              <ATMTable.Cell>{value.planCategory}</ATMTable.Cell>
            </ATMTable.Row>
          ))}
        </ATMTable.Body>
      </ATMTable>
    </ATMSegment>
  );
};

export default FlightRequestAccounting;
